/* CloneAction.js */

"use strict";
const Registrations = require("../../../../../RegistrationNamespaces");
const CreateQuestionComponent = require("../create/CreateQuestionComponent");

class CloneAction {
    constructor(logger, gameEditor, modalUserFeedback, TriggerTypeEntity, userSession, activeView) {
        this._logger = logger;
        this._gameEditor = gameEditor;
        this._tenantId = userSession.activeOrganization.id;
        this._TriggerTypeEntity = TriggerTypeEntity;
        this._triggerTypeEntity = new TriggerTypeEntity(userSession.activeOrganization.id);
        this._modalUserFeedback = modalUserFeedback;
        this._activeView = activeView;

        this.run = this.run.bind(this);
        this.cloneErrorHandler = this.cloneErrorHandler.bind(this);
    }
    run() {
        return this._TriggerTypeEntity
            .getInstanceById(this._tenantId, this._activeView.selectedRows[0])
            .then((selectedTriggerType) => {
                this._triggerTypeEntity.name = selectedTriggerType.name + "-1";
                this._triggerTypeEntity.description = selectedTriggerType.description;
                this._triggerTypeEntity.isPaused = selectedTriggerType.isPaused;
                this._triggerTypeEntity.workInput = selectedTriggerType.workInput;
                this._triggerTypeEntity.workTarget = selectedTriggerType.workTarget;

                switch (selectedTriggerType.triggerType) {
                    case "SCHEDULE":
                        this._triggerTypeEntity.schedule = selectedTriggerType.schedule;
                        break;
                    case "ENTITY_NOTIFICATION":
                        this._triggerTypeEntity.entityNotification = selectedTriggerType.entityNotification;
                        break;
                    case "CONSTRUCT_NOTIFICATION":
                        this._triggerTypeEntity.constructPropertyNotification = selectedTriggerType.constructPropertyNotification;
                        break;
                }
                return this._triggerTypeEntity.create().then((created) => {
                    return this.launchWorkTriggerEditor(created.id, created.properties.name);
                });
            })
            .catch(this.cloneErrorHandler);
    }
    cloneErrorHandler(err) {
        if (err.userRejected) {
            return Promise.resolve();
        }
        this._logger.warn({ error: err }, "Clone action error.");
        return this._modalUserFeedback
            .displayCustom(new CreateQuestionComponent(this._logger, "Please specify a unique name for this cloned work trigger."), {
                dontHide: true
            })
            .then((result) => {
                this._modalUserFeedback.displayLoading();
                this._triggerTypeEntity.name = result;
                return this._triggerTypeEntity.create();
            })
            .then((result) => {
                this.launchWorkTriggerEditor(result.id, result.properties.name);
                return this._modalUserFeedback.hideDisplayed();
            })
            .catch((err) => {
                this.cloneErrorHandler(err);
            });
    }
    launchWorkTriggerEditor(id, name) {
        let editorState = {
            fqn: Registrations.WTE_VIEW_DETAILS,
            viewState: { createMode: true }
        };
        let launchOpts = { id: id, title: name };
        this._gameEditor.launchWorkTriggerEditor(editorState, launchOpts);
    }
}

module.exports = CloneAction;

CloneAction.$inject = [
    "$teve.logger",
    "gameEditor.gameEditor",
    "$teve.ui.userFeedback",
    "$teve.entities.TriggerType",
    "$teve.userSession",
    "gameEditor.activeView"
];

CloneAction.$displayDetails = {
    type: "Action",
    name: "CloneAction",
    icon: "common.duplicate",
    title: "Clone Schedule",
    shown: true,
    order: 4
};
